import { action } from 'satcheljs/lib/legacy';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import checkIfResponseSuccess from 'owa-mail-store/lib/services/utils/checkIfResponseSuccess';
import createSetItemField from 'owa-mail-store/lib/services/utils/createSetItemField';
import itemChange from 'owa-service/lib/factory/itemChange';
import ItemId from 'owa-service/lib/contract/ItemId';
import itemId from 'owa-service/lib/factory/itemId';
import updateItemOperation from 'owa-service/lib/operation/updateItemOperation';
import updateItemRequest from 'owa-service/lib/factory/updateItemRequest';
import UpdateItemResponseMessage from 'owa-service/lib/contract/UpdateItemResponseMessage';

let updateCachedItemChangeKey = function updateCachedItemChangeKey(
    originalItemId: ItemId,
    responseItemId: ItemId
) {
    originalItemId.ChangeKey = responseItemId.ChangeKey;
};

updateCachedItemChangeKey = action('updateCachedItemChangeKey')(updateCachedItemChangeKey);

function createRequestBody(itemIdToUpdate: ItemId) {
    const change = itemChange({
        Updates: [createSetItemField('BlockStatus', false)],
        ItemId: itemId({
            Id: itemIdToUpdate.Id,
            ChangeKey: itemIdToUpdate.ChangeKey,
        }),
    });

    return updateItemRequest({
        ItemChanges: [change],
        ConflictResolution: 'AlwaysOverwrite',
        MessageDisposition: 'SaveOnly',
    });
}

export default function updateItemBlockStatus(itemId: ItemId) {
    const requestBody = createRequestBody(itemId);
    return updateItemOperation({
        Header: getJsonRequestHeader(),
        Body: requestBody,
    }).then(response => {
        const responseMessage = response.Body.ResponseMessages
            .Items[0] as UpdateItemResponseMessage;
        if (checkIfResponseSuccess(responseMessage)) {
            updateCachedItemChangeKey(itemId, responseMessage.Items[0].ItemId);
        }
    });
}
